export class RekbotStatusAssets{
  label: string;
  color: string;
  icon: string;

  constructor(
    label:string,
    color:string,
    icon:string,
  ){
    this.label = label;
    this.color = color;
    this.icon = icon
  }
}